export const SERVICE_RADIUS_KM = 15;
